var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-layout-dev"},[_c('div',{staticClass:"wp-layout-dev__header"},[_vm._v(" "+_vm._s(_vm.$t('calculators.inProcess'))+" ")]),_c('div',{staticClass:"wp-layout-dev__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }